module.exports = __webpack_public_path__ + "img/danger.bca87ec8.gif";